import useRotatingAnimation from "./useRotatingAnimation";

const RotatingAnimation = () => {
  const { dotsRef, matrices } = useRotatingAnimation(16, 1100);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 124"
      width="200"
      height="124"
      preserveAspectRatio="xMidYMid meet"
      className="rotating-animation"
    >
      <defs>
        <clipPath id="__lottie_element_2">
          <rect width="200" height="124" x="0" y="0" />
        </clipPath>
      </defs>
      <g className="rotating-group" clipPath="url(#__lottie_element_2)">
        {matrices.map((matrix, i) => (
          <g
            key={matrix.id}
            ref={(el) => (dotsRef.current[i] = el!)}
            opacity="1"
            className={`dot dot${i + 1}`}
          >
            <path
              fill="rgb(255,255,255)"
              fillOpacity="1"
              d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
            />
          </g>
        ))}
      </g>
    </svg>
  );
};

export default RotatingAnimation;
